export default "__VITE_ASSET__67665d86__"